// Components
import { NumberInput } from "components"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Types
import type { FormType } from "../utils"

export function PaymentDeposit(): JSX.Element {
  // Form
  const { control } = useFormContext<FormType>()

  return (
    <Controller
      name="deposit_amount"
      control={control}
      render={({ field, fieldState }) => (
        <NumberInput
          decimalSeparator="."
          inputClass="text-right"
          label="PAYMENT FROM DEPOSIT"
          thousandSeparator=","
          error={fieldState.error?.message}
          value={field.value}
          ref={field.ref}
          onValueChange={value => field.onChange(value.floatValue ?? 0)}
        />
      )}
    />
  )
}